export default "__VITE_ASSET__BjV2Wrt5__"